import React, { useState, useEffect } from "react";
import "./Blogs.css";
import blogImgone from "../../../Assets/Images/BlogsImage/image 42.png";
import blogImgtwo from "../../../Assets/Images/BlogsImage/image 43.png";
import { Box, Button } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../../api/client";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

function Blogs() {
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestBlogs = async () => {
      try {
        setLoading(true);
        const res = await api.post("/blog/list", {
          status: "published",
          page: 1,
          limit: 2,
        });

        const blogs = res.data.data.map((blog) => ({
          ...blog,
          bannerUrl: blog.thumbnail || null,
        }));

        setBlogData(blogs);
      } catch (err) {
        console.error("Failed to load blogs:", err);
        setError("Failed to load blogs");
      } finally {
        setLoading(false);
      }
    };

    fetchLatestBlogs();
  }, []);


  useEffect(() => {
    console.log("blogData updated:", blogData);
    console.log("blogData structure:", blogData[0]);
  }, [blogData]);

  return (
    <div className="Blogs-section">
      <div className="blog-heading-section">
        <div className="blog-heading">
          <h1>Blogs</h1>
        </div>
        <div className="blog-button">
          <Box>
            <Link to="/blogs" style={{ textDecoration: "none" }}>
              <Button
                variant="outlined"
                sx={{
                  border: "2px solid white",
                  color: "white",
                  width: "170px",
                  height: "50px",
                  borderRadius: "50px",
                  "&:hover": {
                    backgroundColor: "#fff",
                    color: "#000",
                    border: "#fff", // Set the hover background color to transparent
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: 20, // Adjust the size of the icon here
                  },
                }}
              >
                All Blogs <ArrowOutwardIcon />
              </Button>
            </Link>
          </Box>
        </div>
      </div>
      <div className="blog-content">
        <div className="blog-one">
          <div className="blog-inside">
            <div className="blog-one-img">
              <img src={blogData?.[0]?.bannerUrl} alt="" />
            </div>
            <div className="blog-one-content">
              <p>
                {dayjs
                  .utc(blogData?.[0]?.updatedAt)
                  .tz("Asia/Kolkata")
                  .format("MMMM D, YYYY")}
              </p>
              <h3>{blogData?.[0]?.Title}</h3>
              <Box>
                <Button
                  onClick={() => {
                    navigate(`/blogs/${blogData?.[0]?.slug}`, {
                      state: { blogId: blogData?.[0]?._id },
                    });
                  }}
                  variant="outlined"
                  sx={{
                    border: "2px solid white",
                    color: "white",
                    fontFamily: "DM Sans",
                    fontSize: "14.69px",
                    width: "170px",
                    height: "50px",
                    borderRadius: "50px",
                    "&:hover": {
                      backgroundColor: "#fff",
                      color: "#000",
                      border: "#fff", // Set the hover background color to transparent
                    },
                    "& .MuiSvgIcon-root": {
                      fontSize: 20, // Adjust the size of the icon here
                    },
                  }}
                >
                  Read More <ArrowOutwardIcon />
                </Button>
              </Box>
            </div>
          </div>
        </div>
        <div className="blog-two">
          <div className="blog-inside">
            <div className="blog-one-img">
              <img src={blogData?.[1]?.bannerUrl} alt="" />
            </div>
            <div className="blog-one-content">
              <p>
                {dayjs
                  .utc(blogData?.[1]?.updatedAt)
                  .tz("Asia/Kolkata")
                  .format("MMMM D, YYYY")}
              </p>
              <h3>{blogData?.[1]?.Title}</h3>
              <Box>
                <Button
                  onClick={() => {
                    navigate(`/blogs/${blogData?.[1]?.slug}`, {
                      state: { blogId: blogData?.[1]?._id },
                    });
                  }}
                  variant="outlined"
                  sx={{
                    border: "2px solid white",
                    color: "white",
                    fontFamily: "DM Sans",
                    fontSize: "14.69px",
                    width: "170px",
                    height: "50px",
                    borderRadius: "50px",
                    "&:hover": {
                      backgroundColor: "#fff",
                      color: "#000",
                      border: "#fff", // Set the hover background color to transparent
                    },
                    "& .MuiSvgIcon-root": {
                      fontSize: 20, // Adjust the size of the icon here
                    },
                  }}
                >
                  Read More <ArrowOutwardIcon />
                </Button>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blogs;
